// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

// Lazy-loaded Components
const CommunicationHubCreate = lazy(
  () => import('pages/communicationHub/communicationHubCreate')
);
const CommunicationHubEdit = lazy(
  () => import('pages/communicationHub/communicationHubEdit')
);
const CommunicationHubList = lazy(
  () => import('pages/communicationHub/communicationHubList')
);
const CommunicationHubShow = lazy(
  () => import('pages/communicationHub/communicationHubShow')
);

const CommunicationHubRoute = (
  <Route path={routeName.templateDetails}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.TEMPLATE_VIEW,
            PrivateRouteConst.SELF_TEMPLATE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CommunicationHubList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.TEMPLATE_CREATE}>
          <Suspense fallback={<Loading />}>
            <CommunicationHubCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.TEMPLATE_EDIT,
            PrivateRouteConst.SELF_TEMPLATE_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CommunicationHubEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.TEMPLATE_VIEW,
            PrivateRouteConst.SELF_TEMPLATE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CommunicationHubShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default CommunicationHubRoute;
